export const ApiPrefix = '/shop-api'

export const EmailRegExp = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/

export const Payments = [{
  name: '土地銀行劃撥',
  value: 'LandBack_Virtual_ACC',
  mark: '帳號將於送出訂單後提供'
}]

export const DeliverStates = {
  outstanding: '未付款',
  credited: '已付款',
  ready: '待取貨',
  complete: '已取貨',
  revoked: '棄取'
}

export const ProductState = {
  unPublished: '未上架',
  isExpired: '已下架',
  onSale: '上架中'
}

export const RandomHexColor = () => {
  const letters = '0123456789ABCDEF'
  let color = '#'
  for (var i = 0; i < 6; i++) {
    color += letters[Math.floor(Math.random() * letters.length)]
  }
  return color
}

export const RandomRGBAColor = (a = 0.6) => {
  let color = []
  for (var i = 0; i < 3; i++) {
    color.push(Math.floor(Math.random() * 256))
  }
  color.push(a)
  return `rgba(${color.join()})`
}

export const AdminRoles = {
  super: '最高管理員',
  admin: '副管理員',
  editor: '維護人員'
}

export const OpsRecords = {
  'ads-add': '新增首頁輪播廣告',
  'ads-edit': '編輯首頁輪播廣告',
  'ads-delete': '刪除首頁輪播廣告',
  'favor-add': '新增推薦區塊',
  'favor-edit': '編輯推薦區塊',
  'favor-delete': '刪除推薦區塊',
  'favor-item-change': '推薦區塊內容變更',
  'deliver-delete': '刪除訂單',
  'deliver-abandon': '設為棄取訂單',
  'deliver-ready': '備貨完成',
  'deliver-complete': '取貨完成',
  'catalog-purch': '商品進貨',
  'catalog-off': '商品下貨',
  'catalog-add': '新增商品',
  'catalog-edit': '編輯商品',
  'catalog-delete': '刪除商品',
  'catalog-size-delete': '刪除商品型號',
  'classify-add': '新增主分類',
  'classify-edit': '編輯主分類',
  'classify-delete': '刪除主分類',
  'classify-sub-add': '新增子分類',
  'classify-sub-edit': '編輯子分類',
  'classify-sub-delete': '刪除子分類',
  'user-delete': '刪除會員',
  'user-profile-edit': '編輯會員資料',
  'glob-config-edit': '商城設定',
  'payment-config-edit': '金流設定',
  'admin-add': '新增管理者',
  'admin-edit': '編輯管理者',
  'admin-delete': '刪除管理者'
}
const labels = {
  'zh-tw': {
    labelPrevYear: '上一年',
    labelPrevMonth: '上個月',
    labelCurrentMonth: '當前月份',
    labelNextMonth: '下個月',
    labelNextYear: '明年',
    labelToday: '今天',
    labelSelected: '選定日期',
    labelNoDateSelected: '未選擇日期',
    labelCalendar: '日曆',
    labelNav: '日曆導航',
    labelHelp: '使用光標瀏覽日期'
  },
  zh: {
    labelPrevYear: '上一年',
    labelPrevMonth: '上个月',
    labelCurrentMonth: '当前月份',
    labelNextMonth: '下个月',
    labelNextYear: '明年',
    labelToday: '今天',
    labelSelected: '选定日期',
    labelNoDateSelected: '未选择日期',
    labelCalendar: '日历',
    labelNav: '日历导航',
    labelHelp: '使用光标键浏览日期'
  }
}
export const DatepickerLabels = locale => labels[locale] || {}

export const scrollTop = function () {
  const c = document.documentElement.scrollTop || document.body.scrollTop;
  if (c > 0) {
    window.requestAnimationFrame(scrollTop);
    window.scrollTo(0, c - c / 8);
  }
}